<script setup lang="ts">
import DebugTools from '@components/debugtools/DebugTools.vue'
import { setYupLocales } from '@core/plugins/plugin-yup.ts'
import { Toaster } from 'vue-sonner'
import { isDark } from '@composables/dark'
import 'primeicons/primeicons.css'

const { t } = useI18n()
useTheme()
setYupLocales(t)
const favicon = computed(() => {
  if (appType.value === AppType.Qonnected)
    return '/qonnected-favicon.ico'
  return '/onvi-favicon.ico'
})

const themeColor = computed(() => {
  if (appType.value === AppType.Qonnected)
    return '#f7a602'
  return '#f7a602'
})

useHead({
  title: t(`meta.${appType.value}.title`),
  meta: [
    { name: 'description', content: t(`meta.${appType.value}.description`) },
    {
      name: 'theme-color',
      content: themeColor,
    },
  ],
  link: [
    {
      rel: 'icon',
      type: 'image/ico',
      href: favicon,
    },
  ],
})
</script>

<template>
  <div class="bg-slate-100 dark:bg-slate-700" style="min-height: 100vh;">
    <Toaster :theme="isDark ? 'dark' : 'light'" :visible-toasts="9" rich-colors position="bottom-right" :expand="true" />
    <Toast />
    <DebugTools />
    <RouterView />
  </div>
</template>
